import { TableRow } from '@pocketlaw/tetris';
import { SearchResultsTableCell } from './SearchResultsTableCell';
export function SearchResultsTableRow(props) {
    const { result, columnConfigs } = props;
    return (<TableRow>
      {columnConfigs.map(column => (<SearchResultsTableCell key={column.id} column={column} result={result}/>))}
    </TableRow>);
}
